module.exports = __webpack_public_path__ + "img/A-03.0b54089c.png";